/**
 * Fonte ÚNICA do rótulo das ações do histórico do Reembolso (Timeline, Detalhe e Central).
 * Tom e ícone ficam nos mapas locais de cada consumidor; só o TEXTO mora aqui.
 */
import { lerMapa } from '@/utils/reembolsoMapaSeguro';

const ACAO_ROTULO: Record<string, string> = {
  criado: 'Solicitação criada',
  enviado: 'Enviada para aprovação',
  conferencia_iniciada: 'Enviada para conferência',
  conferido: 'Conferência concluída',
  aprovado_nivel: 'Aprovado neste nível',
  aprovado_final: 'Aprovação final',
  pago: 'Pagamento efetuado',
  reprovado: 'Reprovada',
  cancelado: 'Cancelada',
  revisao_solicitada: 'Reaberta para revisão',
  delegacao_aplicada: 'Aprovador delegado',
  nivel_pulado: 'Nível auto-escalado',
  // Exceção auditada (bypass da retenção pela janela de envio).
  janela_antecipada: 'Exceção: enviada ao ERP fora da janela',
  editado_conferente: 'Editado na conferência',
  comprovante_trocado: 'Comprovante trocado',
};

/** `detalhes.troca` de `comprovante_trocado`: anexado (não havia arquivo), trocado ou removido. */
const TROCA_ROTULO: Record<string, string> = {
  anexado: 'Comprovante anexado',
  trocado: 'Comprovante trocado',
  removido: 'Comprovante removido',
};

/** Verbo da troca em minúscula, para frases montadas ("Despesa 2 · comprovante trocado"): não depende do texto do rótulo. */
export const VERBO_TROCA: Record<string, string> = { anexado: 'anexado', trocado: 'trocado', removido: 'removido' };

export function verboTrocaComprovante(detalhes?: Record<string, unknown> | null): string {
  return lerMapa(VERBO_TROCA, detalhes?.troca) ?? VERBO_TROCA.trocado;
}

export function rotuloAcaoHistorico(acao: string, detalhes?: Record<string, unknown> | null): string {
  if (acao === 'comprovante_trocado') {
    const r = lerMapa(TROCA_ROTULO, detalhes?.troca);
    if (r) return r;
  }
  return lerMapa(ACAO_ROTULO, acao) ?? acao;
}
